module.exports = __webpack_public_path__ + "static/media/start-alt-btn-highlight.05920955.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/start-alt-btn-highlight.png
// module id = 606
// module chunks = 0